export default "<app-navyapp></app-navyapp>";